/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useQuery, useMutation } from '@apollo/client';

export const useSubscriptionPreference = () => {
  const FETCH_SUBSCRIPTIONPREFERENCE_GQL = gql`
    query FetchSubs {
	    fetchSubscriptions {
        emailAddress
        firstName
        lastName
        preferredName
        preferredLanguage
        province
        preferences
        subscribeNews
	    }
    }`

  const { data, loading, error, refetch } = useQuery(FETCH_SUBSCRIPTIONPREFERENCE_GQL, {
    fetchPolicy: "network-only",
    skip : process.env.APP_NAME === "TDUSBN"
  });

  return { data, loading, error, refetch };
}

export const useFetchSubscriptionByProductTag = (tag) => {
  const FETCH_SUBSCRIPTIO_BY_PRODUCT_TAG_GQL = gql`
  query FetchProductSubscriptionByProductTag($fetchByProductTagRequest: FetchProductTagSubscriptionRequest!) {
  fetchProductSubscriptionByProductTag(fetchByProductTagRequest: $fetchByProductTagRequest) {
    products
    productNames
  }
}`
  const variables = {
    fetchByProductTagRequest: {
      productTag: tag
    }
  }
  const { data, loading, error } = useQuery(FETCH_SUBSCRIPTIO_BY_PRODUCT_TAG_GQL, {
    variables,
    fetchPolicy: "network-only"
  });

  return { data, loading, error };
}

export const useRemoveSubscriptionProductTag = () => {
  const REMOVE_PRODUCT_TAG_SUBSCRIPTIONS_GQL = gql`
      mutation RemoveProductTagSubscription($removeProdRequest: RemoveProductTagSubscriptionRequest!) {
      removeProductTagSubscription(removeProdRequest: $removeProdRequest)
  }`
  const [updateMutation] = useMutation(REMOVE_PRODUCT_TAG_SUBSCRIPTIONS_GQL);

  return {
    updateMutation: async (removeSubscriptionVar) => {
      return await updateMutation({ variables: { "removeProdRequest": removeSubscriptionVar } })
    }
  };
}